import type { Role } from "@/core/types";

type RouteBase = "/app";

type ExactRole =
  | "admin"
  | "bp"
  | "cse"
  | "csm"
  | "behavioral"
  | "case_manager"
  | "pcp"
  | "peer"
  | "prescribe"
  | "workflow"
  | "patient";

type Config = {
  exactRole: ExactRole;
  routeBase: RouteBase;
};

// Backend maps CARE_MANAGER to provider:pcp
const ROLES_CONF: Record<Role, Config> = {
  "admin:admin": { exactRole: "admin", routeBase: "/app" },
  "admin:billing_partner": { exactRole: "bp", routeBase: "/app" },
  "admin:customer_success_executive": { exactRole: "cse", routeBase: "/app" },
  "admin:customer_success_manager": { exactRole: "csm", routeBase: "/app" },
  "provider:behavioral": { exactRole: "behavioral", routeBase: "/app" },
  "provider:case_manager": { exactRole: "case_manager", routeBase: "/app" },
  "provider:pcp": { exactRole: "pcp", routeBase: "/app" },
  "provider:peer": { exactRole: "peer", routeBase: "/app" },
  "provider:prescribe": { exactRole: "prescribe", routeBase: "/app" },
  "system:workflow": { exactRole: "workflow", routeBase: "/app" },
  "user:patient": { exactRole: "patient", routeBase: "/app" },
};

// TODO: refactor all call sites to use enum
export const admin_admin: Role = "admin:admin";
export const admin_bp: Role = "admin:billing_partner";
export const admin_cse: Role = "admin:customer_success_executive";
export const admin_csm: Role = "admin:customer_success_manager";
export const provider_behavioral: Role = "provider:behavioral";
export const provider_case_manager: Role = "provider:case_manager";
export const provider_pcp: Role = "provider:pcp";
export const provider_peer: Role = "provider:peer";
export const provider_prescribe: Role = "provider:prescribe";
export const system_workflow: Role = "system:workflow";
export const user_patient: Role = "user:patient";

export const adminRoute: RouteBase = "/app";
export const patientRoute: RouteBase = "/app";
export const providerRoute: RouteBase = "/app";

//eventually there should not be any group specific routes
export const baseRoute = "/app";

export default ROLES_CONF;
